export default function () {
    /* cdnUrl, domain, jsDomain, jsDomainBundleApi, sspPlatformJsDomain, elasticSearchVersion2,
           advertiserCurrencies, publisherCurrencies, corporateCurrencies, platforms, adUnits,
           analyticsAdUnits,
           PMPListOfDSP, isProduction, sendMixpanelStaging, sentryReport, userTimingsReport,
           maxPlacementsLimit,
           defaultPlacementsNames, defaultInstancesNames, maxTestDevices, SELF_SERVED_ADVERTISER_ID,
           maxAdUnitInstancesDefault, maxAdUnitIronSourceInstancesWithExtraFlag,
           maxAdUnitInstancesWithExtraFlag,
           googleAdmobSSOClientId, googleAdmobSSORedirectUri, defaultBannerRefreshRate,
           bundlePlatformToSsaPlatform,
           streamRailUrl, providersWithPlatformLimitations,
           applicationPlatformsNamesMapping, sdkConfigurationsMissingConst
      */
    return window.db ? window.db.config : {};
}
